var SpecialRateCriterion;
(function (SpecialRateCriterion) {
    SpecialRateCriterion["LongestTermWithSpecialRate"] = "Longest term with special rate";
    SpecialRateCriterion["LowestSpecialRateWithLongestTerm"] = "Lowest special rate with longest term";
})(SpecialRateCriterion || (SpecialRateCriterion = {}));
const getSpecialRateBasedOnCriterion = (specialRates, specialRateCriterion) => {
    var _a, _b;
    const filterOffers = (filterFn, offers) => !offers || !(offers === null || offers === void 0 ? void 0 : offers.length) ? [] : filterFn(offers);
    const findLongestTermOffers = (offers) => {
        const longestTerm = Math.max(...offers.map(offer => offer.term));
        return offers.filter(offer => offer.term === longestTerm);
    };
    const findLowestRateOffers = (offers) => {
        const longestTermOffers = findLongestTermOffers(offers);
        const lowestRate = Math.min(...longestTermOffers.map(offer => offer.apr));
        return longestTermOffers.filter(offer => offer.apr === lowestRate);
    };
    const filterFunction = specialRateCriterion === SpecialRateCriterion.LongestTermWithSpecialRate || null
        ? findLongestTermOffers
        : findLowestRateOffers;
    const leaseSpecialRate = filterOffers(filterFunction, specialRates === null || specialRates === void 0 ? void 0 : specialRates.lease);
    const financeSpecialRate = filterOffers(filterFunction, specialRates === null || specialRates === void 0 ? void 0 : specialRates.finance);
    return {
        lease: (_a = leaseSpecialRate[0]) !== null && _a !== void 0 ? _a : null,
        finance: (_b = financeSpecialRate[0]) !== null && _b !== void 0 ? _b : null,
    };
};
export default getSpecialRateBasedOnCriterion;
